import { useMemo } from 'react';
import type { FieldProps } from './TextField';
import type { QuestionOption } from '../../types';
import { useFormField } from '../../hooks/useFormField';
import { FieldsetWrapper } from '../QuestionWrapper';

function normalizeOptions(options: QuestionOption[] = []): QuestionOption[] {
  return options.map((option) => {
    // Backend option values can arrive as numbers (e.g. integer-keyed PHP
    // option arrays). Coerce to a string so the controlled `checked`
    // comparison and the stored answer stay the same type.
    const value = String(option.value);

    return {
      ...option,
      value,
      label: option.label || value,
    };
  });
}

export function RadioField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);
  const options = useMemo<QuestionOption[]>(
    () => normalizeOptions(fieldSchema.options),
    [fieldSchema.options]
  );

  return (
    <FieldsetWrapper {...field} fieldSchema={fieldSchema} answered={field.hasAnswered()}>
      <div className="answer-group big-buttons horizontal">
        <div className="inner">
          {options.map((option, key) => (
            <div className="answer" key={option.value}>
              <input
                type="radio"
                checked={String(field.answer) === option.value}
                onChange={() => field.setAnswer(option.value)}
                name={field.getQuestionElementId()}
                id={`${field.getQuestionElementId()}-${key}`}
              />
              <label htmlFor={`${field.getQuestionElementId()}-${key}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>
    </FieldsetWrapper>
  );
}
